import styled, { css } from 'styled-components';

const NAVBAR_VARIANTS = {
  primary: css`
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.35) 13.26%, rgba(0, 0, 0, 0) 102%);

    color: ${({ theme }) => theme.color.primaryForeground};
  `,
  secondary: css`
    background-color: unset;
    color: ${({ theme }) => theme.color.bodyTextColor};
  `,
} as const;

export type NavbarVariant = keyof typeof NAVBAR_VARIANTS;

export const StyledNavContainer = styled.div<{ $variant: NavbarVariant }>`
  margin-top: 45px;
  display: flex;
  flex: 1;
  height: 100px;
  max-height: 100px;
  max-width: 100%;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;

  ${(props) => NAVBAR_VARIANTS[props.$variant]}
`;
export const StyledNavContent = styled.nav`
  display: flex;
  flex: 1;
  max-width: 1200px;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
`;

export const StyledNavItem = styled.div<{ $active?: boolean; $variant: NavbarVariant }>`
  font-size: 18px;
  font-weight: 600;

  &:hover {
    color: ${({ theme, $variant }) =>
      $variant === 'primary' ? theme.color.secondaryForegroundHover : theme.color.primary};
  }
  ${({ $active }) =>
    $active &&
    css`
      text-decoration: underline;
    `}
`;

export const StyledArrowTail = styled.span<{ $variant?: string }>`
  color: ${({ theme, $variant }) =>
    $variant === 'primary' ? theme.color.secondaryForegroundHover : theme.color.bodyTextColor};
`;

export const StyledLogoWrapper = styled.div`
  & > img {
    height: 50px;
  }
`;

export const StyledMenuButton = styled.div`
  align-items: center;
  display: flex;
`;
